import { cn } from '@sohanemon/utils';
import { Iconify } from '@sohanemon/utils/components';
import { m } from '@sohanscript/i18n';
import { localeMeta } from '@sohanscript/i18n/locale-meta';
import { type Locale, locales, setLocale } from '@sohanscript/i18n/runtime';
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuRadioGroup,
	DropdownMenuRadioItem,
	DropdownMenuTrigger,
} from '@sohanscript/ui/dropdown-menu';
import type * as React from 'react';

type LanguageSwitcherProps = React.ComponentProps<'div'> & {
	compact?: boolean;
};

export function LanguageSwitcher({
	className,
	compact,
	...props
}: LanguageSwitcherProps) {
	const activeLocale = localeMeta().locale;

	const selectLocale = (value: string) => {
		if (value === activeLocale) return;
		setLocale(value as Locale);
	};

	return (
		<DropdownMenu {...props}>
			<DropdownMenuTrigger
				aria-label={m.langswitcher_label()}
				className={cn(
					'inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-secondary outline-none transition-colors hover:text-primary focus-visible:ring-2 focus-visible:ring-primary',
					className,
				)}
			>
				<Iconify icon="lucide:globe" className="size-4" />
				{compact ? (
					<span className="hidden font-mono text-xs uppercase tracking-wide xl:inline">
						{localeMeta(activeLocale).label}
					</span>
				) : (
					<span className="font-mono text-xs uppercase tracking-wide">
						{localeMeta(activeLocale).label}
					</span>
				)}
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end" className="w-fit">
				<DropdownMenuRadioGroup
					value={activeLocale}
					onValueChange={selectLocale}
				>
					{locales.map((locale) => (
						<DropdownMenuRadioItem
							key={locale}
							value={locale}
							className="whitespace-nowrap"
						>
							{localeMeta(locale).label}
						</DropdownMenuRadioItem>
					))}
				</DropdownMenuRadioGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
